import { trackEvent } from "@adsk/acc-issues-core/utils/analytics/trackEvent";
import {
  IssueDeleteClickAnalyticsEvent,
  IssueDeleteCancelAnalyticsEvent,
  IssueDeleteConfirmAnalyticsEvent,
} from "./analyticsLib093IssuesEvents";
import { IssueEditBulkEditDeleteSuccessEvent } from "./issueEdit/issueEditBulkEditDeleteSuccessEvent";
import { IssueEditBulkEditDeleteClickEvent } from "./issueEdit/issueEditBulkEditDeleteClickEvent";
import { IssueEditBulkDeleteClickEvent } from "./issueEdit/issueEditBulkDeleteClickEvent";

export const trackIssueDeleteClick = () => {
  trackEvent(new IssueDeleteClickAnalyticsEvent());
};

export const trackIssueDeleteCancel = ({ comment }: { comment: boolean }) => {
  trackEvent(new IssueDeleteCancelAnalyticsEvent({ comment }));
};

export const trackIssueDeleteConfirm = ({
  issueUid,
  comment,
}: ConstructorParameters<typeof IssueDeleteConfirmAnalyticsEvent>[0]) => {
  trackEvent(
    new IssueDeleteConfirmAnalyticsEvent({
      issueUid,
      comment,
    })
  );
};

export const trackIssueBulkDelete = ({ count }: { count: number }) => {
  // @TODO when the infra is fixed we can consume the latest version of
  // PG's analytics lib in the adsk context, create this event in that library and use it
  trackEvent({ name: "issue.edit.bulk_delete.success", parameters: { count } });
};

export const trackIssueBulkDeleteFromBulkEditSidePanel = ({
  selectedCount,
}: {
  selectedCount: number;
}) => {
  trackEvent(new IssueEditBulkEditDeleteSuccessEvent({ selectedCount }));
};

export const trackIssueBulkDeletePartialFailure = ({
  successCount,
  failureCount,
}: {
  successCount: number;
  failureCount: number;
}) => {
  // @TODO when the infra is fixed we can consume the latest version of
  // PG's analytics lib in the adsk context, create this event in that library and use it
  trackEvent({
    name: "issue.edit.bulk_delete.partial_failure",
    parameters: { success_count: successCount, failure_count: failureCount },
  });
};

export const trackIssueBulkDeleteFailure = ({ count }: { count: number }) => {
  // @TODO when the infra is fixed we can consume the latest version of
  // PG's analytics lib in the adsk context, create this event in that library and use it
  trackEvent({ name: "issue.edit.bulk_delete.fail", parameters: { count } });
};

export const trackBulkEditDeleteClickEvent = ({
  selectedCount,
}: {
  selectedCount: number;
}) => {
  trackEvent(new IssueEditBulkEditDeleteClickEvent({ selectedCount }));
};

export const trackBulkDeleteClickEvent = ({
  numberOfIssues,
}: {
  numberOfIssues: number;
}) => {
  trackEvent(new IssueEditBulkDeleteClickEvent({ numberOfIssues }));
};
